import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';
import tradeSvg from './tradeIcon.svg';
import userSvg from './userIcon.svg';
import referralSvg from './referralIcon.svg';

import React from 'react';
import { Row, Col, Button, Input, Popover, Popconfirm } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import { isNotEmpty } from '../Service/Utils';
//import Icon from '@ant-design/icons';


const TradeIcon = props => <img
    {...props}
    alt=""
    src={tradeSvg}
    width="40"
    height="40"
/>;
const UserIcon = props => <img
    {...props}
    alt=""
    src={userSvg}
    width="40"
    height="40"
/>;
const ReferralIcon = props => <img
    {...props}
    alt=""
    src={referralSvg}
    width="40"
    height="40"
/>;

// const MeansureSummaryPopover = props => <Popover
//     title={props.name}>

// </Popover>;

const meansuresConf = {
    TRADE: {
        title: '交易核心指标',
        icon: <TradeIcon />
    },
    USER: {
        title: '用户核心指标',
        icon: <UserIcon />
    },
    REFERRAL: {
        title: '导流核心指标',
        icon: <ReferralIcon />
    },
};

const MeansureSummaryPopover = props => <div style={{ width: 300 }}>
    <Row style={{ margin: '0 0 10px 0' }}>
        <Col>
            <span>指标类型：</span>
            <span style={{ color: 'gray' }}>{meansuresConf[props.category].title}</span>
        </Col>
    </Row>
    <Row style={{ margin: '0 0 10px 0' }}>
        <Col>
            <span>创建人：　</span>
            <span style={{ color: 'gray' }}>{props.creatorName}</span>
        </Col>
    </Row>
    <Row style={{ margin: '0 0 10px 0' }}>
        <Col>
            <span>创建时间：</span>
            <span style={{ color: 'gray' }}>{props.createdAt}</span>
        </Col>
    </Row>
    <Row style={{ margin: '0 0 10px 0' }}>
        <Col>
            <span>更新时间：</span>
            <span style={{ color: 'gray' }}>{props.updatedAt}</span>
        </Col>
    </Row>
    <Row style={{ margin: '0 0 10px 0' }}>
        <Col>
            <span>指标定义：</span>
            <span style={{ color: 'gray' }}>{props.desc}</span>
        </Col>
    </Row>
    <Row justify="center">
        <Col flex="33%" style={{ border: '1px solid rgba(151, 151, 151, 0.45)' }}>
            <Button href={`/data_map/group_measure_desc/detail/${props.id}`} type="link">查看详情</Button>
        </Col>
        <Col flex="33%" style={{ border: '1px solid rgba(151, 151, 151, 0.45)' }}>
            <Button 
                type="link"
                onClick={async ()=>{
                    const rv = await UIFetchService.post(`/api/v1/measure/group/measures/${props.id}/associate_to_sql`);
                    if (isNotEmpty(rv.aid)) {
                        //window.location = `/querying_works?aid=${rv.aid}`;
                        window.open(`/querying_works?aid=${rv.aid}`);
                    }
                }}
            >SQL查询</Button>
        </Col>
        {props.showOffline && <Col flex="33%" style={{ border: '1px solid rgba(151, 151, 151, 0.45)' }}>
            <Popconfirm
                title="是否要下线指定的指标？"
                onCancel={()=>{}}
                onConfirm={()=>props.offline(props.id)}
            >
                <Button danger type="link">下线指标</Button>
            </Popconfirm>
        </Col>}
    </Row>
</div>;

const MeansureSummaryPanel = props => <>
    <Row style={{ margin: '0 0 8px 0' }}>
        <Col style={{ margin: '0 8px 8px 0' }}>
            {props.icon}
        </Col>
        <Col style={{ alignSelf: 'center' }}>
            <h1>{props.title}</h1>
        </Col>
    </Row>
    {(props.dataSource === undefined ? [] : props.dataSource).map(item => <Row key={item.id} style={{ margin: '0 0 13px 0' }}>
        <Col flex="70%">
            <Popover
                title={item.name}
                content={<MeansureSummaryPopover {...item} showOffline={props.showOffline} offline={props.offline}/>}
            >
                <Row>
                    <span>{item.name}</span>
                </Row>
                <Row>
                    <span style={{
                        color: 'gray',
                        fontSize: 12,
                        maxWidth: '300px',
                        textAlign: 'left',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis'
                    }}>{item.desc}</span>
                </Row>
            </Popover>
        </Col>
    </Row>)}
</>;

class GroupMeasureDescView extends React.Component {
    constructor() {
        super();
        this.state = {
            category: 'ALL',
            searchKey: '',
            measures: {
                'TRADE': [],
                'USER': [],
                'REFERRAL': []
            }
        };
    }


    render() {
        return <>
            <div style={{
                backgroundImage: 'url(/measure-bkg.jpeg)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPositionY: '-270px',
                width: '100%',
                height: 100,
                margin: '0 0 10px 0'
            }}>
            </div>
            <Row style={{ margin: '0 0 10px 0' }}>
                <Col flex="25%"></Col>
                <Col flex="50%">
                    <Input.Search
                        value={this.state.searchKey}
                        onChange={({ target: { value } }) => this.refershMeasures(value)}
                        style={{
                            width: '100%'
                        }}
                        placeholder="请输入想要查询的指标名、关键词等进行搜索"
                        enterButton={<Button type="primary">搜索</Button>}
                    />
                </Col>
                <Col flex="25%">
                    <Row>
                        <Col flex="auto"></Col>
                        <Col>
                            <Button
                                icon={<PlusCircleOutlined />}
                                type="link"
                                href="/data_map/group_measure_desc/new"
                            >新增指标</Button>
                        </Col>
                        <Col flex="40px"></Col>
                    </Row>
                </Col>
            </Row>
            <Row style={{ margin: '0 0 20px 0' }}>
                <Col flex="25%"></Col>
                <Col flex="75%" style={{ alignSelf: 'center', textAlign: 'left' }}>
                    <span>指标类型：</span>
                    <CategorySelector
                        value={this.state.category}
                        onChange={category => this.setState({ category })}
                        options={[
                            { key: 'ALL', title: '全部' },
                            { key: 'TRADE', title: '交易' },
                            { key: 'USER', title: '用户' },
                            { key: 'REFERRAL', title: '导流' },
                        ]}
                    />
                </Col>
            </Row>
            {this.state.category === 'ALL' && <Row style={{ margin: '0 0 10px 0' }} justify='center'>
                <Col flex="30%">
                    <MeansureSummaryPanel
                        {...meansuresConf.TRADE}
                        showOffline={this.state.showOffline}
                        offline={this.offlineMeasure.bind(this)}
                        dataSource={this.state.measures.TRADE}
                    />
                </Col>
                <Col flex="30%">
                    <MeansureSummaryPanel
                        {...meansuresConf.USER}
                        showOffline={this.state.showOffline}
                        offline={this.offlineMeasure.bind(this)}
                        dataSource={this.state.measures.USER}
                    />
                </Col>
                <Col flex="30%">
                    <MeansureSummaryPanel
                        {...meansuresConf.REFERRAL}
                        showOffline={this.state.showOffline}
                        offline={this.offlineMeasure.bind(this)}
                        dataSource={this.state.measures.REFERRAL}
                    />
                </Col>
            </Row>}
            {this.state.category !== 'ALL' && <Row style={{ margin: '0 0 10px 0' }} justify='center'>
                <Col flex="30%">
                    <MeansureSummaryPanel
                        {...meansuresConf[this.state.category]}
                        showOffline={this.state.showOffline}
                        offline={this.offlineMeasure.bind(this)}
                        dataSource={this.state.measures[this.state.category]}
                    />
                </Col>
            </Row>}
        </>;
    }

    async componentDidMount() {
        await auth.authenticate();
        const showOffline = auth.allow("datap:admin");
        this.setState({ showOffline });

        await this.refershMeasures('');
        auth.appendLog(`数据地图-集团核心指标`);
    }

    async refershMeasures(searchKey) {
        this.setState({ searchKey });
        const measures = await UIFetchService.get(`/api/v1/measure/group/measures?searchKey=${searchKey}`);
        this.setState({measures});
    }

    async offlineMeasure(id) {
        await UIFetchService.delete(`/api/v1/measure/group/measures/${id}`, {});
        await this.refershMeasures(this.state.searchKey);
    }
}

class CategorySelector extends React.Component {

    render() {
        return <>
            {this.props.options.map(opt =>
                <span
                    key={opt.key}
                    style={{
                        cursor: 'pointer',
                        color: this.props.value === opt.key ? '#1193E7' : 'black',
                        margin: '0 0 0 20px'
                    }}
                    onClick={() => this.props.onChange(opt.key)}
                >
                    {opt.title}
                </span>)}
        </>
    }
};

export default GroupMeasureDescView;